import { useEffect } from "react";
import { useGeneralContext } from "../context/AppGeneralContext";
import { useTestCreationContext } from "../context/TestCreationContext";

/**
 * Links an anonymously-created test to the account once the user is authenticated.
 *
 * The anonymous create flow stores the new test id in localStorage and has the user log in or
 * register (summary popups). Afterwards the test has to be re-linked to the now logged-in
 * account via checkForAnonymousTests(). This used to run only on the /assistent mount,
 * so opening /create/anonymous directly (which lands on /create after login) never
 * linked the test. Keying on the session instead makes the claim run wherever the user lands
 * once it is established, and regardless of whether they were already logged in when they
 * entered the flow. It waits for userInfo to be non-anonymous as well: the popup login sets
 * userId before user-info resolves, and the claim's analytics must not go out as "anonymous".
 */
export default function AnonymousTestClaimer() {
    const { userId, userInfo } = useGeneralContext();
    const { checkForAnonymousTests } = useTestCreationContext();

    const isLoggedIn = !!userId && !userInfo.isAnonymousUser;

    useEffect(() => {
        if (isLoggedIn) {
            checkForAnonymousTests();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    return null;
}
